import { Component, Input } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Learnspace, User } from '@shared/models';
import { AuthenticationService } from '@shared/services/authentication.service';
import { AddParticipantDialogComponent } from '../add-participant-dialog/add-participant-dialog.component';

@Component({
  selector: 'user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss']
})

export class UserListComponent {
  @Input() learnspace: Learnspace;
  @Input() limit: number | undefined;

  constructor(
    private _authService: AuthenticationService,
    private _dialog: MatDialog
  ) { }

  showLsParticipants(event: any): void {
    event.stopPropagation();
    const user = this._authService.wondaUser.id;
    this._dialog.open(AddParticipantDialogComponent, {
      width: '500px', height: '60vh',
      data: { learnspace: this.learnspace, user_id: user} }
    );
  }

  getParticipantNames(): string {
    const names = this.getUsersWithinLimit().map(this.getUserName).join(', ');
    return this.hasHiddenUsers() ? `${names}, ...` : names;
  }

  getParticipantInitials(): string[] {
    return this.getUsersWithinLimit()
      .map(this.getUserName)
      .map(name => {
        return name
          .split(/\s+/)
          .map(s => s.length ? s[0].toUpperCase() : '')
          .join('')
          .substring(0, 2);
      });
  }

  private hasHiddenUsers(): boolean {
    return this.limit && this.learnspace?.Participants && this.limit < this.learnspace.Participants.length;
  }

  private getUsersWithinLimit(): User[] {
    return this.learnspace?.Participants ? this.learnspace.Participants.slice(0, this.limit) : [];
  }

  private getUserName(user: User): string {
    return [user.first_name, user.last_name].filter(s => !!s).join(' ');
  }
}
